module.exports = __webpack_public_path__ + "img/SKMJ_standard9.091bc096.jpg";